import { Link, Spark } from "@scoach/ui/icons";

import { safeHref } from "../../../../lib/safeHref.ts";
import { useLiveMeetingStore } from "../store.ts";

/**
 * "What's New" panel — replaces the old Charts tab. Shows recently released
 * Google products/features/models relevant to the live conversation, surfaced
 * by the grounded announcements generator (server-side, Google Search grounded).
 */
export function WhatsNewPanel() {
  const announcements = useLiveMeetingStore((s) => s.announcements);
  const activeTag = useLiveMeetingStore((s) => s.activeTagFilter);
  const setActiveTag = useLiveMeetingStore((s) => s.setActiveTagFilter);

  if (announcements.length === 0) {
    return (
      <div className="ig-empty">
        <Spark size={28} color="var(--text-4)" />
        <div className="ig-empty-title">What's New</div>
        <div className="ig-empty-sub">
          Recent Google releases relevant to this call will appear here.
        </div>
      </div>
    );
  }

  return (
    <div className="infographic-panel" style={{ minHeight: 0 }}>
      <div
        className="scroll"
        style={{ padding: "10px 12px", display: "flex", flexDirection: "column", gap: 10 }}
      >
        {announcements.map((a) => (
          <div
            key={a.id}
            style={{
              border: "1px solid var(--border, #e0e0e0)",
              borderRadius: 8,
              padding: "10px 12px",
              background: "var(--surface, #fff)",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 8,
                marginBottom: 6,
              }}
            >
              <span
                style={{
                  fontSize: 11,
                  fontWeight: 600,
                  color: "var(--gc-green, #137333)",
                  background: "var(--gc-green-50, #e6f4ea)",
                  borderRadius: 999,
                  padding: "2px 8px",
                  whiteSpace: "nowrap",
                }}
              >
                {a.recencyLabel}
              </span>
              {a.releaseDate && (
                <span className="mono" style={{ fontSize: 11, color: "var(--text-4)" }}>
                  {a.releaseDate}
                </span>
              )}
            </div>
            <div style={{ fontSize: 12, fontWeight: 600, color: "var(--gc-blue, #1a73e8)" }}>
              {a.productName}
            </div>
            <div style={{ fontSize: 14, fontWeight: 600, lineHeight: 1.3, margin: "2px 0 4px" }}>
              {a.title}
            </div>
            <div style={{ fontSize: 13, color: "var(--text-2, #444)", lineHeight: 1.45 }}>
              {a.summary}
            </div>
            {a.relatedTopic && (
              <div
                style={{ fontSize: 12, color: "var(--text-4)", marginTop: 6, fontStyle: "italic" }}
              >
                Re: {a.relatedTopic}
              </div>
            )}
            {a.tags && a.tags.length > 0 && (
              <div style={{ display: "flex", flexWrap: "wrap", gap: 6, marginTop: 8 }}>
                {a.tags.map((tag) => (
                  <button
                    key={tag}
                    type="button"
                    className={`tag-chip${activeTag === tag ? " on" : ""}`}
                    onClick={() => setActiveTag(activeTag === tag ? null : tag)}
                    title={`Filter hints by "${tag}"`}
                  >
                    {tag}
                  </button>
                ))}
              </div>
            )}
            {a.url && (
              <a
                href={safeHref(a.url)}
                target="_blank"
                rel="noreferrer"
                style={{
                  display: "inline-flex",
                  alignItems: "center",
                  gap: 4,
                  fontSize: 12,
                  marginTop: 8,
                  color: "var(--gc-blue, #1a73e8)",
                  textDecoration: "none",
                }}
              >
                <Link size={12} /> Source
              </a>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
